export default "__VITE_ASSET__BggA$eQO__"